import { setFaqItemOpen } from "./_faqAccordion";

const SELECTORS = {
  TABS: "tabs__item",
  TABS_ACTIVE: "tabs__item--active",
  FAQ_ITEMS: "faq__item",
};

export class FaqTabs {
  constructor() {
    this.tabs = document.querySelectorAll(`.${SELECTORS.TABS}`);
    this.faqItems = document.querySelectorAll(`.${SELECTORS.FAQ_ITEMS}`);

    this.setListeners();
    this.toggleFaqItemsVisibility();
  }

  setListeners() {
    this.tabs.forEach((tab) =>
      tab.addEventListener("click", (event) => this.tabClickHandler(event)),
    );
  }

  tabClickHandler(event) {
    event.preventDefault();

    const activeTab = document.querySelector(`.${SELECTORS.TABS_ACTIVE}`);
    activeTab.classList.remove(SELECTORS.TABS_ACTIVE);
    activeTab.removeAttribute("aria-current");

    // currentTarget — сама ссылка, даже если клик пришёл по вложенному элементу
    const tab = event.currentTarget;
    tab.classList.add(SELECTORS.TABS_ACTIVE);
    tab.setAttribute("aria-current", "true");
    this.toggleFaqItemsVisibility(tab);
  }

  toggleFaqItemsVisibility(tab = null) {
    let activeTab = null;
    if (tab) {
      activeTab = tab;
    } else {
      activeTab = document.querySelector(`.${SELECTORS.TABS_ACTIVE}`);
    }
    const href = activeTab.href;
    const tabSection = href.slice(href.indexOf("#") + 1);

    this.faqItems.forEach((item) => {
      if (item.dataset.section !== tabSection) {
        item.style.display = "none";
        // Закрыть скрытые элементы
        setFaqItemOpen(item, false);
      } else {
        item.style.display = "block";
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new FaqTabs();
});
